export default function SystemStatus({ children, soundEnabled, onSoundChange }) {
  return (
    <div className="system-status" role="status" aria-live="polite">
      <strong className="system-status-label">SISTEMA:</strong>
      <span className="system-status-message">{children}</span>
      <label className="system-status-sound">
        <input
          type="checkbox"
          checked={soundEnabled}
          onChange={(event) => onSoundChange(event.target.checked)}
        />
        So al finalitzar
      </label>
    </div>
  );
}
